// extracted by mini-css-extract-plugin
module.exports = {"tooltipWpapper":"TooltipGlodal_tooltipWpapper__3Bk-H"};